var React = require('react');

function IcEletricityComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-eletricity"},React.createElement("path",{"id":"icons/ic-eletricidade","fillRule":"evenodd","clipRule":"evenodd","d":"M4.37866 9.64054C4.37866 9.57976 4.39178 9.51874 4.41835 9.46167L7.93668 1.8989C8.008 1.74595 8.16425 1.64746 8.33594 1.64746H13.1947C13.359 1.64746 13.509 1.73693 13.5848 1.87978C13.6177 1.9422 13.634 2.0102 13.634 2.07797C13.634 2.1653 13.6069 2.25225 13.5535 2.32639L10.0208 7.23693H12.5245C12.6954 7.23693 12.8509 7.33433 12.923 7.48693C12.9947 7.6388 12.9701 7.8181 12.8598 7.9458L5.48782 16.4949C5.40216 16.5948 5.27789 16.6475 5.15253 16.6475C5.07827 16.6475 5.0029 16.6294 4.93488 16.5905C4.7507 16.4873 4.66834 16.2705 4.7382 16.0746L6.87971 10.071H4.81761C4.66834 10.071 4.52938 9.99667 4.44849 9.87329C4.40219 9.80287 4.37866 9.72192 4.37866 9.64054ZM8.6183 2.50857L5.50069 9.21023H7.49809C7.64074 9.21023 7.77419 9.27733 7.85617 9.39133C7.93853 9.50533 7.95985 9.65143 7.91279 9.78274L6.35142 14.1597L11.5782 8.0984H9.1738C9.00983 8.0984 8.85947 8.00893 8.7841 7.86608C8.70837 7.72322 8.72087 7.55078 8.81498 7.41911L12.3477 2.50857H8.6183Z","fill":"#FF8E2A"})));
}

IcEletricityComponent.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = IcEletricityComponent;

IcEletricityComponent.default = IcEletricityComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/EditDataModalV2/images/ic-eletricity.component.svg
// module id = 695
// module chunks = 0